'use strict';
// -------------------------------------------//
//              Directive Icon
// -------------------------------------------//
angular.module('app.directives.icon', []).directive('icon', [
    '$timeout', '_IMAGE2CLASS', 'ENUM', '$filter',
    function($timeout, _IMAGE2CLASS, ENUM, $filter) {
        var obj = {
            scope: {
                // Icon Object (Device or Menuentry or Scene etc.…)
                object: '=object',
                objectType: '=objectType',
                //iconListAnimated: '=iconListAnimated'
                iconAnimated: '@iconAnimated',
                iconAnimatedTimeout: '@iconAnimatedTimeout'

            },
            restrict: 'AE',
            template: '',

            link: function(scope, element) {
                var oldClass;
                scope.initClass = element.attr('class');
                scope.DeviceTypes = ENUM.getDeviceTypesByFilter(1);

                updateIconImage();

                //scope.$watch('object', function(value, oldvalue) {
                //    element.attr('class', scope.initClass);
                //    if (oldvalue && value != oldvalue) {
                //        element.removeClass('icon-' + oldvalue.ImageName);
                //    }

                //    //console.log(scope.objectType);
                //    scope.o = value;
                //    if (value && value.Entry != undefined) {
                //        doSetClass(scope.object.Entry, element, scope);
                //    } else {
                //        doSetClass(scope.object, element, scope);
                //    }
                //}, true);

                scope.$on('$destroy', function() {
                    $timeout.cancel(scope.to);
                    //// console.log('captured $destroy event');
                });

                scope.$on('ImageNameChanged', function() {
                    updateIconImage();
                });

                function updateIconImage() {
                    element.attr('class', scope.initClass);

                    if (scope.object) {
                        if (scope.object.OldImageName && scope.object.OldImageName !== scope.object.ImageName) {
                            element.removeClass('icon-' + scope.object.OldImageName);
                        }
                        if (scope.object.ImageName) {
                            scope.object.OldImageName = scope.object.ImageName;
                        }
                    }

                    //console.log(scope.objectType);
                    scope.o = scope.object;

                    if (scope.object && scope.object.Entry !== undefined) {
                        doSetClass(scope.object.Entry, element, scope);
                    } else {
                        doSetClass(scope.object, element, scope);
                    }
                }

                function doAnimate() {
                    if (scope.iconAnimatedTimeout == undefined) {
                        scope.iconAnimatedTimeout = 500;
                    }
                    for (var i = 0; i < scope.icons.length; i++) {

                        if (scope.icons[i].animated == true) {
                            var oldIndex = scope.icons[i].aktindex;
                            var newIndex;
                            if ((oldIndex + 1) == scope.icons[i].icons.length) {
                                newIndex = 0;
                            } else {
                                newIndex = oldIndex + 1;
                            }
                            scope.icons[i].aktindex = newIndex;
                        }
                    }
                    $timeout.cancel(scope.to);
                    if (scope.animated == true) {
                        scope.to = $timeout(doAnimate, scope.iconAnimatedTimeout);
                    }
                }

                function chooseCorrectDeviceType(o) {
                    if (o !== undefined && Number.isInteger(o)) {
                        return o;
                    }
                    else if (o !== undefined && typeof o === 'string' && o !== '') {
                        return +o;
                    }
                    else {
                        return o.DeviceType;
                    }
                }

                // -------------------------------------------//
                //              Set the Class
                // -------------------------------------------//
                function doSetClass(o, element, scope) {
                    // Icon is for a Device

                    // For Raumregelung we get object.Entry
                    // so we have to check

                    //	console.log(o);
                    var setClass = '';
                    var ot = scope.objectType;
                    scope.animated = false;
                    if (o && o.Datapoint && o.Datapoint.DatapointConfig && o.Datapoint.DatapointConfig.$UI && o.Datapoint.DatapointConfig.$UI.KnownImageName) {
                        setClass = o.Datapoint.DatapointConfig.$UI.KnownImageName;
                    }
                    if (o
                        && o.DeviceId !== undefined
                        && o.FavoriteId === undefined
                        && o.MenuEntryId === undefined
                        && o.SceneId === undefined
                        && o.CustomActionName === undefined
                        && o.DatapointConfigId === undefined


                    ) {
                        ot = 'DeviceType';
                        //o = o.DeviceType;
                    }

                    if (ot != undefined) {
                        let thisDT;
                        switch (ot) {

                            case "DatapointConfig":
                                if (o.KnownImageName) {
                                    setClass = o.KnownImageName;
                                }

                                break;
                            case "DeviceType":
                                thisDT = $filter('filter')(scope.DeviceTypes, {
                                    $pk: chooseCorrectDeviceType(o)
                                }, true);
                                if (thisDT.length === 1) {
                                    setClass = thisDT[0].Image.Name;
                                }
                                //if (scope.DeviceTypes.hasOwnProperty(o)) {}
                                break;
                            case "DeviceTypePlural":
                                //if (scope.DeviceTypes.hasOwnProperty(o)) {
                                thisDT = $filter('filter')(scope.DeviceTypes, {
                                    $pk: chooseCorrectDeviceType(o)
                                }, true);
                                if (thisDT.length === 1) {
                                    setClass = 'plural-' + thisDT[0].Image.Name;
                                }
                                // }

                                break;
                            case "MessageType":
                                switch (parseInt(o)) {
                                    case 0:
                                        setClass = 'email';
                                        break;
                                    case 1:
                                        setClass = 'email';
                                        break;
                                    case 2:
                                        setClass = 'sms';
                                        break;

                                }
                                break;
                            case "Condition":
                                if (o.TimeProgram) {
                                    // O.k. we got a TimeProgram Condition
                                    if (o.TimeProgram.WeekProgramEntries != null && o.TimeProgram.YearProgramEntries != null) {
                                        setClass = 'zeitprogramm';
                                    } else if (o.TimeProgram.WeekProgramEntries != null) {
                                        setClass = 'woechentlich';
                                    } else if (o.TimeProgram.YearProgramEntries != null) {
                                        if (o.TimeProgram.YearProgramEntries[0].Start == null || o.TimeProgram.YearProgramEntries[0].Start == '0001-01-01T00:00:00') {
                                            setClass = 'von';
                                        } else if (o.TimeProgram.YearProgramEntries[0].End == null || o.TimeProgram.YearProgramEntries[0].End == '0001-01-01T00:00:00') {
                                            setClass = 'bis';
                                        } else {
                                            setClass = 'von-bis';
                                        }
                                    }
                                }

                                break;
                        }
                        scope.setClass = setClass;

                        element.addClass('icon-' + setClass);
                    }
                    // icon is a number or a string
                    if (typeof o == "number" || typeof o == "string") {
                        scope.setClass = 'icon-' + o;
                        element.addClass('icon-' + o);
                        oldClass = o;
                    }

                    // iconstring is defined by template
                    if (o && o.iconstring != undefined) {
                        element.addClass('icon-' + o.iconstring);
                        oldClass = o.iconstring;
                        scope.setClass = oldClass;
                    } else if (typeof o == 'object' && o.length > 1) {
                        // Something like ['fenster-auf','fenster-auf']
                        // Do combined icons.
                        scope.withTemplate = true;
                        if (scope.iconAnimatedTimeout == undefined) {
                            scope.iconAnimatedTimeout = 100;
                        }
                        //console.log('ARRAY Icon');
                        scope.icons = [];
                        for (var i = 0; i < o.length; i++) {
                            var obj = {};

                            obj.aktindex = 0;
                            if (typeof o[i] == 'object' && o[i].length > 0) {
                                obj.animated = true;
                                scope.animated = true;

                                obj.icons = o[i];
                            } else {
                                obj.icons = [o[i]];
                            }
                            scope.icons.push(obj);
                        }
                        //console.log(scope.icons)


                    } else if (typeof o == 'object') {


                        // icon is a object
                        // Check by ImageName
                        if (o && o.ImageName != null && o.ImageName != "") {

                            //var cl = $rootScope.ImageNameToIconClass(o.ImageName);
                            if (o.ImageName && _IMAGE2CLASS.hasOwnProperty(o.ImageName)) {

                                element.addClass('icon-' + _IMAGE2CLASS[o.ImageName]);
                                oldClass = o.ImageName;

                            } else {

                                /* kovandja 2018-08-22
                                   Removes previously set class if any is already set.
                                   It would be better to just set a class correctly once,
                                   but the code is too brittle right now and I do not want
                                   to break it further. */
                                if (setClass && setClass !== '') {
                                    element.removeClass('icon-' + setClass);
                                    setClass = '';
                                }

                                if (o.ImageName.indexOf('_') !== -1) {
                                    // If we got a TOPAZ Imagename like abmelden_102x70
                                    setClass = o.ImageName.split('_')[0];
                                    
                                    if (setClass.length > 2) {
                                        if (setClass.substring(0, 2) === '1-') {
                                            setClass = setClass.replace('1-', 'ein');
                                        } else if (setClass.substring(0, 2) === '2-') {
                                            setClass = setClass.replace('2-', 'zwei');
                                        } else if (setClass.substring(0, 2) === '4-') {
                                            setClass = setClass.replace('4-', 'vier');
                                        }
                                    }
                                } else {
                                    setClass = o.ImageName;
                                }

                                scope.setClass = setClass;
                                element.addClass('icon-' + setClass);
                                oldClass = setClass;
                            }
                            return true;


                        } else {
                            // We get a Favorite
                            if (o && o.FavoriteId) {
                                element.addClass('icon-favorit');
                                if (setClass != undefined) {
                                    oldClass = setClass;
                                }
                                return true;
                            }


                            // We get a Device
                            if (o
                                && (o.DeviceId !== undefined || o.DeviceType !== undefined)
                                && o.MenuEntryId === undefined
                                && o.SceneId === undefined
                                && o.CustomActionName === undefined
                                && (o.DatapointConfigId === undefined && o.MenuEntryId === undefined)
                            ) {

                                if (scope.DeviceTypes.hasOwnProperty(o)) {
                                    setClass = scope.DeviceTypes[o].Image.Name;
                                }
                                element.addClass('icon-' + setClass);
                                oldClass = setClass;

                                return true;
                            }

                            // We get a MenuEntry
                            // Pending is if a room is added but not saved. Display Icon already
                            if (o
                                && (o.MenuEntryId !== undefined || o.MenuEntryId === 'Pending')
                                && o.MenuEntryType !== undefined) {


                                switch (o.MenuEntryType) {

                                    case 0:
                                        setClass = 'raum';
                                        break;
                                    case 1:
                                        setClass = 'ordner';
                                        break;
                                    case 2:
                                        setClass = 'ordner';
                                        break;
                                    case 3:
                                        setClass = 'ordner';
                                        break;
                                    default:
                                        setClass = 'raum';
                                }
                                element.addClass('icon-' + setClass);
                                oldClass = setClass;
                                return true;
                            }

                            // We get a Scene
                            if (o && o.SceneId) {
                                switch (o.DisplayName) {
                                    case "Party":
                                        setClass = 'party';
                                        break;
                                    default:
                                        setClass = 'szene';

                                }
                                element.addClass('icon-' + setClass);
                                oldClass = setClass;
                                return true;
                            }



                        }

                    }
                    $timeout.cancel(scope.to);
                    if (scope.animated == true) {
                        scope.to = $timeout(doAnimate, scope.iconAnimatedTimeout);
                    }
                }
            }

        };

        return obj;
    }
]);
